import { ReactElement } from 'react';

import { AssistantGenerateRoutesDialogPreAsignedDriverAction } from '../../../../../../Components';

import { useAssistantGenerateRoutesDialogByTemplateContext } from '../../../../../Context';

import {
  // eslint-disable-next-line max-len
  AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataPreAssignedDriverCardContainer as Card,
  // eslint-disable-next-line max-len
  AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataPreAssignedDriverCardContent as CardContent,
} from './styles';

const AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataPreAssignedDriverCard =
  (): ReactElement => {
    const {
      data: {
        selectedDriver: { value: selectedDriver, setValue: setSelectedDriver },
      },
    } = useAssistantGenerateRoutesDialogByTemplateContext();

    return (
      <Card variant="outlined">
        <CardContent>
          <AssistantGenerateRoutesDialogPreAsignedDriverAction
            currentDriver={selectedDriver}
            onAssigned={(currentDriver) => setSelectedDriver(currentDriver)}
          />
        </CardContent>
      </Card>
    );
  };

// eslint-disable-next-line max-len
export default AssistantGenerateRoutesDialogByTemplateContentFormTemplateSelectedDataPreAssignedDriverCard;
